import { useQuery, useMutation } from 'react-query';
import axiosClient from './axiosClient';

export const settingApi = {
  getAll(params) {
    return axiosClient
      .get('/settings', { params })
      .then((response) => response?.data || []);
  },
  getByKey(key, params) {
    return axiosClient
      .get(`/settings/${key}`, { params })
      .then((response) => response?.data || null);
  },
  update(key, data) {
    return axiosClient.patch(`/settings/${key}`, data);
  },
};

export const useSettings = ({ params, options } = {}) => {
  return useQuery({
    queryKey: ['settings', 'list', params],
    queryFn: () => settingApi.getAll(params),
    ...options,
  });
};

export const useSetting = ({ id, params, options } = {}) => {
  return useQuery({
    queryKey: ['settings', 'details', id, params],
    queryFn: () => settingApi.getByKey(id, params),
    ...options,
  });
};

export const useUpdateSetting = (key) => {
  return useMutation((data) => settingApi.update(key, data));
};
